<template>
  <div class="wrapper">
    <a href="https://team-hf.se"><img src="https://team-hf.se/wordpress/wp-content/themes/teamhf/images/logo.png" alt="Team hälso &amp; friskvård"></a>
    <h2 class="title">Kundbeställning</h2>
    <div class="intro">{{$root.intro}}</div>
    <div class="templates" v-html="$root.documents.html"></div>
    <div class="loading" v-bind:class="{hidden : $root.status !== 'loading' }">
      <p>Var god vänta. Dina filer laddas upp.</p>
    </div>
    <div class="complete" v-bind:class="{hidden : $root.status !== 'complete' }">
      <p>Allt klart. Din kundbeställning har skickats.</p>
      <h3>Sammanställning</h3>
      <div>{{$root.name}}<br>{{$root.workplace}}<br>{{$root.email}}<br>{{$root.message}}</div>
      <h4>Uppladde filer</h4>
      <ul>
        <li v-for="item in $root.files" :key="item.file">
          {{ item.file }}
        </li>
      </ul>
      <div class="buttons">
        <button v-on:click="reset()" class="submit-button">Ny beställning</button>
      </div>
    </div>
    <form @submit.prevent="submit" v-bind:class="{hidden : $root.status !== 'idle' }">
      <div class="field-group">
        <label class="field-wrapper">
          <span class="field-label">Beställare <em>*</em></span>
          <input type="text" v-model="$root.name" class="field" required>
        </label>
        <label class="field-wrapper">
          <span class="field-label">Arbetsplats/företag <em>*</em></span>
          <input type="text" v-model="$root.workplace" class="field" required>
        </label>
        <label class="field-wrapper">
          <span class="field-label">E-post <em>*</em></span>
          <input type="text" v-model="$root.email" class="field" required>
        </label>
        <label class="field-wrapper">
          <span class="field-label">Telefon <em>*</em></span>
          <input type="text" v-model="$root.phone" class="field" required>
        </label>
        <div class="upload">
          <VueFileAgent
                  ref="vueFileAgent"
                  :theme="'list'"
                  :multiple="true"
                  :deletable="true"
                  :meta="true"
                  :accept="'.pdf, .doc, .docx, .xls, .xlsx'"
                  :maxSize="'10MB'"
                  :maxFiles="14"
                  :helpText="'Ladda upp fil (pdf, doc, docx, xls, xlsx)'"
                  :errorText="{
      type: 'Otillåten filtyp.',
      size: 'För stor fil. Maxstorlek 10MB.',
    }"
                  @select="filesSelected($event)"
                  @beforedelete="onBeforeDelete($event)"
                  @delete="fileDeleted($event)"
                  @upload="onUpload($event)"
                  v-model="fileRecords"
          ></VueFileAgent>
        </div>
        <div style="clear:both;"></div>
        <label class="field-wrapper">
          <span class="field-label">Meddelande</span>
          <textarea v-model="$root.message" class="field" rows="5"></textarea>
        </label>
      </div>
      <button :disabled="!fileRecordsForUpload.length" class="submit-button" type="submit">Skicka</button>
    </form>
    <footer>
      <h3>TEAM hälso & friskvård</h3>
      <ul>
        <li>Göteborgsvägen 97</li>
        <li>431 37 Mölndal</li>
        <li>Telefon: 031-723 28 00</li>
        <li><a href="mailto:info@team-hf.se">info@team-hf.se</a></li>
        <li>© 2020 Team hälso- & friskvård</li>
      </ul>
    </footer>
  </div>
</template>

<script>
    export default {
        data: function () {
            return {
                fileRecords: [],
                uploadUrl: 'https://team-hf.se/kundbestallning/upload.php',
                uploadHeaders: { 'X-Test-Header': 'vue-file-agent' },
                fileRecordsForUpload: [],
                createFormData: {test:'test'}
            };
        },
        methods: {
            reset() {
                location.reload();
            },
            submit() {
                this.uploadFiles(this.$root.workplace);
                this.$root.status = 'loading';
            },
            uploadFiles: function () {
                for(var i=0; i<this.fileRecordsForUpload.length; i++){
                    this.fileRecordsForUpload[i].formData = {
                        data: this.$root,
                    };
                }
                console.log(this.fileRecordsForUpload[0]);
                this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload, function createFormData(fileData){
                    var formData = new FormData();
                    console.log(fileData);
                    formData.append('action', 'upload');
                    formData.append('name', fileData.raw.formData.data.name);
                    formData.append('workplace', fileData.raw.formData.data.workplace);
                    formData.append('email', fileData.raw.formData.data.email);
                    formData.append('phone', fileData.raw.formData.data.phone);
                    formData.append('message', fileData.raw.formData.data.message);
                    formData.append('file', fileData.file);
                    return formData;
                });
                this.fileRecordsForUpload = [];
            },
            onUpload:function (responses) {
                this.$root.status = 'complete';
                for(var i=0; i<responses.length; i++) {
                    this.$root.files.push({file:responses[i].data['my_key']});
                }
                // Send mail https://team-hf.se/wp-json/wco-api/v1/mail
                const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        message: this.$root.message,
                        email: this.$root.email,
                        phone: this.$root.phone,
                        name: this.$root.name,
                        workplace: this.$root.workplace
                    })
                };
                fetch('https://team-hf.se/wp-json/wco-api/v1/mail', requestOptions).then(r => r.json()).then(r => {
                    console.log('response', r);
                });
                //console.log(this.$root.message);
            },
            deleteUploadedFile: function (fileRecord) {
                // Using the default uploader. You may use another uploader instead.
                this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
            },
            filesSelected: function (fileRecordsNewlySelected) {
                var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
                this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
            },
            onBeforeDelete: function (fileRecord) {
                var i = this.fileRecordsForUpload.indexOf(fileRecord);
                if (i !== -1) {
                    this.fileRecordsForUpload.splice(i, 1);
                } else {
                    if (confirm('Are you sure you want to delete?')) {
                        this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
                    }
                }
            },
            fileDeleted: function (fileRecord) {
                var i = this.fileRecordsForUpload.indexOf(fileRecord);
                if (i !== -1) {
                    this.fileRecordsForUpload.splice(i, 1);
                } else {
                    this.deleteUploadedFile(fileRecord);
                }
            },
        },
    };
</script>

<style>
  body {
    background: #fcfcfc;
  }
  footer {
    margin-top: 50px;
    text-align: center;
    font-size: 12px;
    border-top: 1px solid #ccc;
    margin-bottom: 50px;
  }
  .wrapper {
    text-align: left;
    max-width: 400px;
    margin: 0 auto;
    font-size: 16px;
  }
  .hidden {
    display: none;
  }
  form, .upload, .complete, .loading{
    clear: both;
    margin: 30px 0;
  }
  form span{
    float: left;
    clear: both;
    width: 100%;
  }
  form input, form textarea {
    border: 1px solid #d6d6d6;
    padding: .72222em;
    box-sizing: border-box;
    width: 100%;
    font-size: inherit;
  }
  em {
    color: #f07800;
  }
  h2, h3, h4 {
    margin-bottom: 5px;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .templates {
    margin-top: 10px;
  }
  .submit-button{
    background: #ffffff;
    border: 1px solid #f07800;
    color: #f07800;
    text-align: center;
    text-decoration: none;
    display: block;
    position: relative;
    padding: .72222em .88889em;
    width: 100%;
    font-size: inherit;
    cursor: pointer;
  }
  .buttons .submit-button {
    width: 40%;
    margin-right: 2%;
    display: inline-block;
    margin-top: 30px;
  }
  .submit-button:hover {
    background: #f07800;
    color: #ffffff;
  }

  .field-wrapper {
    display: block;
    margin-bottom: 15px;
  }
  .field-label {
    margin: 0 0 .33333rem;
  }
  .wrapper .vue-file-agent.file-input-wrapper {
    border: 1px solid #d6d6d6;
  }
  .wrapper .vue-file-agent .file-preview-new svg {
    fill: #000 !important;
  }
  .wrapper .theme-list .vue-file-agent .file-preview-new .help-text {
    color: #000;
  }
  .wrapper .vue-file-agent .file-error-wrapper .file-error-message {
    width: 300px;
  }
</style>